import { Link } from "react-router-dom";
import { EmptyState, PageHeader } from "../components/ui";

export function NotFoundPage() {
  return (
    <>
      <PageHeader title="Page not found" subtitle="There is nothing at this address." />
      <EmptyState title="Check the link, or start from Home." action={<Link to="/">Go to Home</Link>} />
    </>
  );
}
